var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-campaign-targeting-rule',[_c('div',[_vm._v("The campaign will be appear if "+_vm._s(_vm.data.filter)+" "+_vm._s(_vm.data.value)+" pages are visited.")])])}
var staticRenderFns = []

export { render, staticRenderFns }